import React, { useState, useEffect, useRef } from "react";
import axios from "axios";
import Sidebar from "../../SideComponents/BlogsSidebar";
import Styles from "../../../assets/css/Blogs/ProblemSolving/SlowLaptop.module.css";
import debounce from "lodash.debounce"; // lodash.debounce , It will Add delay to observer that can help stoping the flickerings
import { Helmet } from "react-helmet-async";

// Global States imports
import { useGlobalState } from "../../../Functions/GlobalStates";

const SlowLaptop = () => {
  const questionId = "2"; // Replace with dynamic question ID
  const [likes, setLikes] = useState(0); // State to hold the number of likes
  const [Views, setViews] = useState(0); // State to hold the number of likes
  // Global States
  const { PagesWidthHeight, setPagesWidthHeight } = useGlobalState();
  // React useRef Refferences
  const CheckSlowLaptopSize = useRef(false);

  // Fetching images
  const SlowLaptopSolutionImages = require.context(
    "../../../assets/images/Blogs/ProblemSolving/SlowLaptop", // Path to the directory
    false, // Do not include subdirectories (set to true if you want to include them)
    /\.(png|PNG|jpg|jpeg|webp|svg|avif)$/ // Regular expression to match file types
  );
  const SolutionImages = [
    SlowLaptopSolutionImages("./screen1.avif"), // Dynamically load the image
    SlowLaptopSolutionImages("./screen2.avif"), // Dynamically load the image
    SlowLaptopSolutionImages("./screen3.avif"), // Dynamically load the image
    SlowLaptopSolutionImages("./screen4.avif"), // Dynamically load the image
    SlowLaptopSolutionImages("./screen5.avif"), // Dynamically load the image
  ];

  // updating height to modify sidebar height
  useEffect(() => {
    const updateSize = () => {
      const { height } = CheckSlowLaptopSize.current.getBoundingClientRect();
      setPagesWidthHeight((prev) => ({
        ...prev,
        height: parseFloat(height.toFixed(1)),
      }));
      // console.log("Heigth", height);
    };

    updateSize(); // Run once on mount
    // Debounce Will Help Derease the Consuption of the Ram & Limit Bulk re-Runing Funtions in a Sec
    const updateSizeDelay = debounce(updateSize, 100);
    window.addEventListener("resize", updateSize);
    window.addEventListener("scroll", updateSizeDelay);

    // Cleanup function to remove event listener when component unmounts
    return () => {
      window.removeEventListener("resize", updateSize);
      window.removeEventListener("scroll", updateSizeDelay);
    };
  }, []);

  // Fetch Likes From Database
  useEffect(() => {
    const AllViews = async () => {
      const hasViewed = localStorage.getItem(`viewed_${questionId}`); // Check if user has already viewed this question

      try {
        if (hasViewed) {
          // alert("You have already Viewed this question.");
          // Fetching the current view data
          const ViewsResponse = await axios.get(
            `https://affiliators.netlify.app/.netlify/functions/server/api/getviews/${questionId}`
          );
          if (ViewsResponse.data && ViewsResponse.data.views !== undefined) {
            setViews(ViewsResponse.data.views); // Update the state with the number of views
            // alert('Thank you for Viewing the question!');
          } else {
            console.error("No view data received from the get req and server");
          }
        } else {
          // Sending PUT request to the server to update or create the view count
          const ViewsResponse = await axios.put(
            `https://affiliators.netlify.app/.netlify/functions/server/api/views/${questionId}`
          );

          if (ViewsResponse.data && ViewsResponse.data.views !== undefined) {
            setViews(ViewsResponse.data.views); // Update the state with the number of views
            localStorage.setItem(`viewed_${questionId}`, "true"); // Mark as viewed in localStorage
            // alert("Thank you for Viewing the question!");
          } else {
            console.error("No view data received from the put req and server");
          }
        }
      } catch (error) {
        console.error("Error updating views:", error.message);

        // Check if the error is due to the document not being found
        if (error.response && error.response.status === 404 && !hasViewed) {
          // Retry by invoking GET request to create the data if missing
          try {
            // Retry the GET request only if the user has not viewed yet
            const retryResponse = await axios.get(
              `https://affiliators.netlify.app/.netlify/functions/server/api/getviews/${questionId}`
            );
            if (retryResponse.data && retryResponse.data.views !== undefined) {
              setViews(retryResponse.data.views); // Update state with the number of views
              // alert("Thank you for Viewing the question!");
            } else {
              console.error("No view data received from the retry GET request");
            }
          } catch (retryError) {
            console.error("Error on retrying GET request:", retryError.message);
            // alert("Error retrying to fetch view data. Please try again later.");
          }
        } else {
          // alert("Error updating views. Please try again later.");
        }
      }
    };

    AllViews();

    const fetchOrAddLikes = async () => {
      try {
        const fetchresponse = await axios.get(
          `https://affiliators.netlify.app/.netlify/functions/server/api/checklikes/${questionId}`
        ); // Fetch or create likes
        setLikes(fetchresponse.data.likes); // Update state with the number of likes
      } catch (error) {
        console.error("Error fetching or adding likes:", error.message);
      }
    };

    fetchOrAddLikes();
  }, []);

  const HandleLike = async () => {
    const hasLiked = localStorage.getItem(`liked_${questionId}`); // Check if user has liked the question

    if (hasLiked) {
      // alert("You have already liked this question.");
      return;
    }
    try {
      const response = await axios.put(
        `https://affiliators.netlify.app/.netlify/functions/server/api/updatelikes/${questionId}`
      ); // Send request to backend
      setLikes(response.data.likes); // Update the likes state with the latest count

      // Store in localStorage to prevent multiple likes
      localStorage.setItem(`liked_${questionId}`, "true");
      // alert("Thank you for liking the question!");
    } catch (error) {
      console.error("Error updating likes:", error.message);
    }
  };

  const SidebarProps = {
    RTL1: "https://answers.microsoft.com/en-us/windows/forum/all/issues-within-programs-after-startup/e92deebb-255c-4929-8c14-f95f398a6e87",
    RTL2: "https://or.stackexchange.com/questions/7425/ram-requirement-for-optimization-problems",
    RTL3: "https://support.microsoft.com/en-us/windows/tips-to-improve-pc-performance-in-windows-b3b3ef5b-5953-fb6a-2528-4bbed82fba96",
    RTL4: "https://www.techradar.com/news/computing/pc/15-task-manager-tips-for-a-faster-pc-649623",
    RTL5: "https://answers.microsoft.com/en-us/windows/forum/all/background-processes-using-cpumemorydisk/88c35f38-99cb-4fb4-b25c-a375cd28e1ec",
    RTL6: "https://www.hp.com/us-en/shop/tech-takes/how-to-speed-up-computer",
    RTC1: "Startup programs",
    RTC2: "Memory optimization",
    RTC3: "PC performance",
    RTC4: "Task Manager tips",
    RTC5: "Background processes",
    RTC6: "System speed-up",
  };

  return (
    <>
      <Helmet>
        {/* Page Title */}
        <title>
          Slow Laptop Because of High Memory Usage by Startup Apps 💻
        </title>

        {/* Meta Description */}
        <meta
          name="description"
          content="Learn why your laptop slows down due to high memory usage from startup apps and discover easy fixes to boost performance."
        />

        {/* Keywords for SEO */}
        <meta
          name="keywords"
          content="Slow Laptop, High Memory Usage, Startup Apps, Laptop Performance, Speed Up Laptop, Memory Optimization"
        />

        {/* Responsive Design */}
        <meta name="viewport" content="width=device-width, initial-scale=1" />

        {/* Open Graph Meta Tags for Social Sharing */}
        <meta
          property="og:title"
          content="Slow Laptop Because of High Memory Usage by Startup Apps 💻"
        />
        <meta
          property="og:description"
          content="Learn why your laptop slows down due to high memory usage from startup apps and discover easy fixes to boost performance."
        />
        <meta property="og:type" content="article" />
        <meta
          property="og:url"
          content="https://affiliators.netlify.app/#/problemsolving/slowlaptop"
        />
        {/* <meta
          property="og:image"
          content="/images/SlowLaptop/slowlaptop1.png"
        /> */}

        {/* Twitter Meta Tags for Social Sharing */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta
          name="twitter:title"
          content="Slow Laptop Because of High Memory Usage by Startup Apps 💻"
        />
        <meta
          name="twitter:description"
          content="Learn why your laptop slows down due to high memory usage from startup apps and discover easy fixes to boost performance."
        />
        {/* <meta
          name="twitter:image"
          content="/images/SlowLaptop/slowlaptop1.png"
        /> */}

        {/* Robots Meta Tag */}
        <meta name="robots" content="index, follow" />

        {/* Canonical URL */}
        {/* <link
          rel="canonical"
          href="https://affiliators.netlify.app/#/problemsolving/slowlaptop"
        /> */}

        {/* Additional Meta Tags */}
        <meta name="author" content="Zeeshan Ahmad Kamran" />
        <meta name="language" content="en" />
        <meta http-equiv="Content-Language" content="en" />
      </Helmet>

      <div className={Styles.BlogSidebarSlowLaptopContainer}>
        <Sidebar {...SidebarProps} />
        <div ref={CheckSlowLaptopSize} className={Styles.SlowLaptopContainer}>
          <section className={Styles.SlowLaptopSection1Container}>
            <div
              className={Styles.SlowLaptopSection1QuestionLikesViewsContainer}
            >
              <h4>Problem</h4>
              <h1>Slow Laptop Because Of High Memory Usage by Startup Apps.</h1>
              <div className={Styles.SlowLaptopSection1LikesViewsContainer}>
                <button
                  className={Styles.LikeButton}
                  onClick={HandleLike}
                  aria-label="Like this question"
                >
                  👍🏻 {likes}
                </button>
                <span>{Views} Views</span>
              </div>
            </div>
          </section>
          <section className={Styles.SlowLaptopSection2Container}>
            <div className={Styles.SlowLaptopSection2AnswerContainer}>
              <h4>Solution</h4>
              <p>Follow These Steps:</p>
              <h3>Step No. 1 ....</h3>
              <p>Watch this video:</p>
              <iframe
                className={Styles.SlowLaptopSection2AnswerVideo1}
                src="https://www.youtube.com/embed/ghOkqLRDNls?si=p96UURnkIl5BNhul"
                title="YouTube video player"
                frameBorder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                referrerPolicy="strict-origin-when-cross-origin"
                allowFullScreen
              ></iframe>
              <p>
                If the following video solved your problem, feel free to skip
                the remaining steps. If not, continue with the next steps ⬇️
              </p>
              <h3>
                Step 2: Identify High Memory Usage Apps & Disable Unnecessary
                Startup Apps
              </h3>
              <h3>For Windows Users</h3>
              <div className={Styles.SlowLaptopSection2AnswerImagesContainer}>
                <div className={Styles.SlowLaptopSection2AnswerImgContainer}>
                  <p>👉🏻 Open Task Manager (Ctrl + Shift + Esc).</p>
                  <img src={SolutionImages[0]} alt="loding step 2" />
                </div>
                <div className={Styles.SlowLaptopSection2AnswerImgContainer}>
                  <p>👉🏻 Navigate to the Startup tab.</p>
                  <img src={SolutionImages[2]} alt="loding step 2" />
                </div>
                <div className={Styles.SlowLaptopSection2AnswerImgContainer}>
                  <p>
                    👉🏻 Check the Startup Impact column to identify high-resource
                    apps.
                  </p>
                  <img src={SolutionImages[1]} alt="loding step 3" />
                </div>
              </div>
              <h3>Step 3: Disable Unnecessary Startup Programs</h3>
              <div className={Styles.SlowLaptopSection2AnswerImagesContainer}>
                <div className={Styles.SlowLaptopSection2AnswerImgContainer}>
                  <p>👉🏻 In Task Manager, right-click on unwanted apps.</p>

                  <p>
                    👉🏻 Select Disable to prevent them from launching at startup.
                  </p>
                  <img src={SolutionImages[3]} alt="loding step 2" />
                </div>
                <div className={Styles.SlowLaptopSection2AnswerImgContainer}>
                  <p>👉🏻 Restart your system to apply changes.</p>
                  <img src={SolutionImages[4]} alt="loding step 3" />
                </div>
              </div>
              <p>
                I hope you found this helpful! 👍✨ Don't forget to rate this
                blog!
              </p>
            </div>
          </section>
        </div>
      </div>
    </>
  );
};

export default SlowLaptop;
